
export enum TransformType {
    rowExtractor = 0,
    activityNamer = 1,
    eventGroupNamer = 2,
    eventNamer = 3,
    groupNamer = 4,
    groupAttributor = 5,
    groupFiller = 6,
    columnCleaner = 7,
    columnCalc = 8,
    columnLookup = 9,
    farmConverter = 10,
    farmJoiner = 11,
    rowFiller = 12,
    anonymizer=15
}

export class TransformTypeUtil {
    static toString(transformerType: TransformType): string {
        switch (transformerType) {
          case TransformType.rowExtractor:
            return 'Row Extractor Transform';

          case TransformType.activityNamer:
            return 'Activity Namer Transform';

          case TransformType.eventGroupNamer:
            return 'Event Group Namer Transform';

          case TransformType.eventNamer:
            return 'Event Namer Transform';

          case TransformType.groupAttributor:
            return 'Group Attributor Transform';
  
          case TransformType.farmConverter:
            return 'Farm Converter Transform';
    
          case TransformType.columnCalc:
            return 'Column Calc Transform';
            //return 'Column Calculation Transform';

          case TransformType.columnLookup:
            return 'Column Lookup Transform';

          case TransformType.farmJoiner:
            return 'Farm Joiner Transform';
    
          case TransformType.rowFiller:
            return 'Row Filler Transform';

          case TransformType.anonymizer:
            return 'Anonymizer Transform';
          case TransformType.columnCleaner:
            return 'Column Cleaner Transform';
          default:
            return '';
        }
      }
}

export class TransformDefaultTypeUtil {
  static toString(transformerType: number): string {
    switch (transformerType) {
    case TransformType.rowExtractor:
      return 'Row Extractor';
    case TransformType.activityNamer:
      return 'Activity Namer';
    case TransformType.eventGroupNamer:
      return 'Event Group Namer';
    case TransformType.eventNamer:
      return 'Event Namer';
    case TransformType.groupAttributor:
      return 'Group Attributor';
    case TransformType.columnCalc:
      return 'Column Calc';
      //return 'Column Calculator';
    case TransformType.columnLookup:
      return 'Column Lookup';
    case TransformType.farmConverter:
      return 'Farm Converter';
    case TransformType.farmJoiner:
      return 'Farm Joiner';
    case TransformType.rowFiller:
      return 'Row Filler';
    case TransformType.anonymizer:
      return 'Anonymizer';
    case TransformType.columnCleaner:
      return 'Column Cleaner';

    case 99:
      return 'Ingest Node';
    case 100:
      return 'Input Farm';
    default:
      return '';
  }
}
}

export enum CacheKeyType {
    node = 1,
    transformer = 2,
    tempTransformer = 3,
    ingestRaw = 4,
    ingestInput = 5,
    transformerOutput = 6,
    transformerResult = 7
}
export enum PreviewType {
    ingestRaw = 1,
    ingestInput = 2,
    ingestOutput = 3,
    nodeInput = 4,
    nodeOutput = 5,
    transInput = 6,
    transOutput = 7,
    transOutputTemp = 8,
    transResultTemp = 9,
    transLookupInput = 10,
    joinerInputA = 11,
    joinerInputB = 12,
    joinerInputC = 13,
    joinerInputD = 14,
    joinerInputE = 15,
    joinerOutput = 16,
    joinerResult = 17,
    converterInput = 18,//no input converter later check
    converterOutput = 19,
    converterResult = 20,
    refineryInput = 21,
    refineryOutput = 22,
    joinerInputF = 23,
    joinerInputG = 24,
    joinerInputH = 25,
    joinerInputI = 26,
    joinerInputJ = 27,
}

export function getEnumValue<T extends object>(
  enumObj: T,
  key: string
): T[keyof T] | undefined {
  return key in enumObj ? enumObj[key as keyof T] : undefined;
}


